<div class="gateway-caption">
  <status-icon [status]="status()"></status-icon>
  <div class="gateway-caption__text">
    <div class="gateway-caption__title">{{ gateway().gateway_name }}</div>
    <div class="gateway-caption__subtitle">
      <span>{{ gateway().gateway_id }} - {{ gateway().tenant_name }}</span>
      <span class="gateway-caption__separator">&middot;</span>
      @if (lastSeen(); as seen) {
        <span class="gateway-caption__last-seen" [matTooltip]="lastSeenExact()">
          {{ seen | timeago: locale() }}
        </span>
      } @else {
        <span class="gateway-caption__last-seen">{{ "Iotnet.Never" | translate }}</span>
      }
    </div>
  </div>
</div>
